import { render } from "./JiraProject.vue?vue&type=template&id=6222f393"
import script from "./JiraProject.vue?vue&type=script&lang=js"
export * from "./JiraProject.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__